module.exports = __webpack_public_path__ + "static/media/salidaEmergencia1.8d5d9c4f.png";